<template>
  <div class="message-card-wrapper">
    <div class="message-card">
      <div class="card-header-row">
        <div class="card-header-left">
          <p class="company-name">{{ message.companyName }}</p>
          <p class="sender-name">{{ message.sender }}</p>
          <p class="subject-text">{{ message.subject }}</p>
        </div>
        <p class="sent-date">{{ formatDate }}</p>
      </div>

      <div class="divider"></div>

      <div class="preview-body" v-html="sanitizedBody"></div>

      <div class="jd-info" v-if="message.jd_display && message.jd_snapshot">
        <div class="jd-title" @click="openJdModal">
          <span class="jd-title-text">{{ message.jd_snapshot.job_title }}</span>
        </div>
      </div>

      <div class="button-container d-flex flex-column align-items-center" v-if="!isOtherNotifications">
        <button class="btn btn-apply" :disabled="true">
          <span class="btn-main-text" v-html="applyButtonMainText"></span>
          <span class="btn-sub-text" v-if="message.contact_type !== 'カジュアル面談'">回答画面に進みます</span>
        </button>
        <button class="btn btn-refrain" :disabled="true">
          <span class="btn-main-text">今回は控える</span>
          <span class="btn-sub-text" v-if="showDifferentPositionButton">別求人への希望も可能です</span>
        </button>
      </div>
    </div>

    <div class="file-request-section" v-if="!isOtherNotifications">
      <label class="file-request-label">不足書類の提出依頼</label>
      <label class="mr-4">
        <input type="checkbox" :disabled="true" value="職務経歴書" v-model="message.file_upload_request" />
        職務経歴書
      </label>
      <label>
        <input type="checkbox" :disabled="true" value="履歴書" v-model="message.file_upload_request" />
        キャリア登録情報ではない独自の履歴書
      </label>
    </div>

    <IndividualJDModal
      v-if="showJdModal"
      :jd="message.jd_snapshot"
      :submitButtonText="submitButtonText"
      :contactType="message.contact_type"
      :isOpen="showJdModal"
      :isOtherNotifications="isOtherNotifications"
      :isQuestionRequest="message.question_request || false"
      :company="message.companyName"
      :showDifferentPosition="showDifferentPositionButton"
      @closeJdModal="closeJdModal"
    />
  </div>
</template>

<script>
import DOMPurify from 'dompurify';
import moment from 'moment';
import IndividualJDModal from './IndividualJDModal.vue';

export default {
  name: 'MessageDetail',
  props: ['message', 'company'],
  components: { IndividualJDModal },
  data() {
    return {
      showJdModal: false,
    };
  },
  computed: {
    formatDate() {
      return moment(this.message.sent_date).format('M月D日');
    },
    isOtherNotifications() {
      return this.message.contact_type === 'その他通知';
    },
    showDifferentPositionButton() {
      if (this.isOtherNotifications) return false;
      if (!this.message.scout_profile_enabled) return false;
      return this.message.contact_type === '応募案内' || this.message.contact_type === '面接案内';
    },
    applyButtonMainText() {
      if (this.message.contact_type === '面接案内') return '面接に参加する';
      if (this.message.contact_type === 'カジュアル面談') return 'カジュアル面談に<br/>参加する';
      return '応募する';
    },
    submitButtonText() {
      if (this.message.contact_type === '応募案内') {
        return '<span style="font-size:12px">応募回答画面に</span><br/><span>進む</span>';
      } else if (this.message.contact_type === 'カジュアル面談') {
        return 'カジュアル面談に<br/>参加する';
      }
      return '<span>選考に応募して</span><br/><span>面接に参加する</span>';
    },
    sanitizedBody() {
      const processed = this.processEmailBody(this.message.body.trim());
      return DOMPurify.sanitize(processed, { ADD_ATTR: ['target'] });
    },
  },
  methods: {
    processEmailBody(htmlString) {
      const linkRegex = /<a[^>]+href=["']([^"']*)["']/g;
      const processedHTML = htmlString.replace(linkRegex, (match, link) => {
        if (!link || link === 'undefined' || link === '#' || link.trim() === '') {
          return match.replace(/<a/i, '<span').replace(/href=["'][^"']*["']/i, '');
        }
        if (!/^https?:\/\//i.test(link)) {
          return match.replace(link, `https://${link}`);
        }
        return match;
      });
      const urlRegex = /(?<!<a[^>]*)(https?:\/\/[^\s<]+|www\.[^\s<]+\.[^\s<]+)(?![^<]*>)/g;
      return processedHTML.replace(urlRegex, url => `<a href="${url}">${url}</a>`);
    },
    openJdModal() {
      this.showJdModal = true;
    },
    closeJdModal() {
      this.showJdModal = false;
    },
  },
};
</script>

<style scoped>
.message-card-wrapper {
  background-color: #ebeff1;
}

.message-card {
  background-color: #fff;
  padding: 16px 20px 10px;
}

.card-header-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 8px;
}

.card-header-left {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.company-name {
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 6px;
}

.sender-name {
  font-size: 12px;
  margin: 0 0 4px;
}

.subject-text {
  font-size: 13px;
  margin: 0;
  word-break: break-word;
}

.sent-date {
  font-size: 13px;
  font-weight: bold;
  margin: 0;
  white-space: nowrap;
  flex-shrink: 0;
}

.divider {
  border-bottom: 1px solid #ccc;
  margin: 8px 0;
}

.preview-body {
  font-size: 13px;
  word-break: break-word;
  white-space: pre-line;
  padding: 8px 0 4px;
}

.jd-info {
  padding: 10px 0;
  text-align: center;
}

.jd-title {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #b3b3b3;
  padding: 16px 10px;
  border-radius: 3px;
  color: #036ac9;
  font-weight: bold;
  cursor: pointer;
  margin: 0;
  font-size: 14px;
  overflow: hidden;
}

.jd-title-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
}

.jd-title-plus {
  flex-shrink: 0;
  margin-left: 4px;
  width: 19px;
  height: 19px;
  font-size: 19px;
  line-height: 19px;
  color: #707070;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.button-container {
  padding: 20px 10px 10px;
  gap: 10px;
}

.btn-apply {
  background-color: #006C6B !important;
  border-color: #006C6B !important;
  color: #fff !important;
  width: 325px;
  height: 60px;
  padding: 20px 25px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  font-weight: bold;
  opacity: 1 !important;
  pointer-events: none;
}

.btn-refrain {
  background-color: #fff !important;
  color: #000 !important;
  border: 1px solid #000 !important;
  width: 325px;
  height: 60px;
  padding: 20px 25px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  font-weight: bold;
  opacity: 1 !important;
  pointer-events: none;
}

.btn-main-text {
  display: block;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
}

.btn-sub-text {
  display: block;
  font-size: 11px;
  margin-top: 2px;
  font-weight: normal;
}

.btn-refrain .btn-sub-text {
  color: #FD1010 !important;
}

.file-request-section {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  padding: 10px 14px;
  font-size: 11px;
  color: #3c3c3c;
  background-color: #eaeef1;
}

.file-request-label {
  font-weight: 500;
  margin: 0;
}

.file-request-section label {
  display: flex;
  align-items: center;
  gap: 4px;
  margin: 0;
}

.file-request-section input[type='checkbox'] {
  width: 14px;
  height: 14px;
}
</style>
